module.exports = __webpack_public_path__ + "img/OIP.445de36d.jpg";